import { useProject } from '@contexts/Project.context';
import LayerSettings from './sidebarElements/LayerSettings';

const TrainingDataSingleImgToggleBtn = () => {
	const { trainingDataVisible, dispatch } = useProject();

	const handleCheck = () => {
		dispatch({ type: 'setTrainingDataVisible', payload: true });
	};

	const handleUncheck = () => {
		dispatch({ type: 'setTrainingDataVisible', payload: false });
	};

	return (
		<li>
			<LayerSettings
				id="trainingDataSingleImage"
				label="Training Data"
				defaultState={trainingDataVisible}
				onCheck={handleCheck}
				onUncheck={handleUncheck}
			/>
		</li>
	);
};

export default TrainingDataSingleImgToggleBtn;
